
import { bulkImportAdd, getImportLists, DelBulkImport, getImportTableHeader, bulkImportGetFields, getImportValidFormat, getImportAggregation, bulkImportSetFields } from '@/services/config'
import i18n from '@/lib/language'
export default {
  namespaced: true,
  state: {
    tableSort: {},
    sortedInfo: {},
    defaultColumns: [
      {
        title: i18n.t('message["936"]') + 'ID',
        dataIndex: 'taskid',
        key: 'taskid',
        slots: { title: 'taskid' },
        scopedSlots: { customRender: 'taskid' },
        sorter: true,
        width: 110
      }, {
        title: i18n.t('message["83"]'),
        dataIndex: 'operator',
        width: 120
      },
      {
        title: i18n.t('message["126"]'),
        dataIndex: 'addtime',
        key: 'addtime',
        slots: { title: 'addtime' },
        scopedSlots: { customRender: 'addtime' },
        sorter: true,
        width: 120
      },
      {
        title: i18n.t('message["1646"]'),
        dataIndex: 'status',
        key: 'status',
        slots: { title: 'status' },
        scopedSlots: { customRender: 'status' },
        width: 160
      },
      {
        title: i18n.t('message["1239"]'),
        dataIndex: 'finishtime',
        key: 'finishtime',
        slots: { title: 'finishtime' },
        scopedSlots: { customRender: 'finishtime' },
        sorter: true,
        // defaultSortOrder: 'ascend',
        width: 120
      },
      {
        title: i18n.t('message["191"]'),
        dataIndex: 'successnum',
        key: 'successnum',
        slots: { title: 'successnum' },
        scopedSlots: { customRender: 'successnum' },
        width: 120
      },
      {
      // title: '导入失败',
        dataIndex: 'failnum',
        key: 'failnum',
        slots: { title: 'failTitle' },
        scopedSlots: { customRender: 'failnum' },
        width: 160
      },
      {
        title: i18n.t('message["79"]'),
        dataIndex: 'fileurl',
        key: 'fileurl',
        slots: { title: 'fileurl' },
        scopedSlots: { customRender: 'fileurl' },
        width: 200
      }],
    listDatas: [{
      id: 1,
      addtime: '2020-1-10',
      status: '1',
      finishtime: '2020-2-1',
      successNum: 10,
      errorNum: 1,
      file: 'xxx.csv'
    }],
    pagination: {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      allCount: 0
    },

    loading: true,
    excelHeader: {
      A: i18n.t('message["621"]'),
      B: i18n.t('message["35"]'),
      C: i18n.t('message["620"]'),
      D: i18n.t('message["549"]'),
      E: i18n.t('message["1047"]'),
      F: i18n.t('message["373"]'),
      G: i18n.t('message["1234"]'),
      H: i18n.t('message["1358"]'),
      I: i18n.t('message["1372"]')
    },
    importFields: {},
    // 离开当前页面给出提示
    isBackObj: {
      status: false,
      count: 0,
      leave: {},
      hasSumbit: false
    }
  },
  mutations: {
    setListDatas (state, data) {
      state.listDatas = data
    },
    setExcelHeader (state, data) {
      state.excelHeader = data
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    setImportFields (state, data) {
      state.importFields = data
    },
    SET_TABLE_SORT (state, { tableSort = {}, sorter = {} }) {
      state.tableSort = Object.assign({}, tableSort)
      state.sortedInfo = sorter
    },
    setIsBackObj (state, data) {
      state.isBackObj = Object.assign({}, state.isBackObj, data)
    }
  },
  getters: {
    columns (state) {
      const { defaultColumns } = state
      defaultColumns.forEach(item => {
        if (item.sorter) {
          item.sortOrder = state.sortedInfo.columnKey === item.dataIndex && state.sortedInfo.order
          /* if (state.sortedInfo.columnKey === item.dataIndex) {
            item.defaultSortOrder = state.tableSort.sorttype === 1 ? 'ascend' : state.tableSort.sorttype === 2 ? 'descend' : false
            // item.defaultSortOrder = state.tableSort.sorttype === 1 ? 'ascend' : 'descend'
          } */
        }
      })
      return defaultColumns
    }
  },
  actions: {
    async bulkImportAdd ({ commit }, params) {
      let chain = await bulkImportAdd()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async fetchImportList ({ commit }, params) {
      commit('SET_LOADING', true)
      let chain = await getImportLists()
      chain
        .params(params)
        .onSuccess(raw => {
          commit('setListDatas', raw)
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },
    async deleteBulkImport ({ commit, dispatch }, params) {
      let chain = await DelBulkImport()
      chain
        .params(params)
        .onSuccess(raw => {
          dispatch('fetchImportList')
        })
        .fetch()
      return chain
    },
    async fetchImportTableHeader ({ commit }, params) {
      commit('SET_LOADING', true)
      let chain = await getImportTableHeader()
      chain
        .params(params)
        .onSuccess(raw => {
          commit('setExcelHeader', raw.tableheader)
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },

    async fetchImportFields ({ commit }, params) {
      let chain = await bulkImportGetFields()
      chain
        .params(params)
        .onSuccess(raw => {
          commit('setImportFields', raw)
        })
        .fetch()
      return chain
    },
    async importValidFormat ({ commit }, params) {
      let chain = await getImportValidFormat()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async fetchImportAggregation ({ commit }, params) {
      let chain = await getImportAggregation()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async setFields ({ commit }, params) {
      let chain = await bulkImportSetFields()
      chain
        .params(params)
        .fetch()
      return chain
    },
    addClick () {
      window.onbeforeunload = function (e) {
        return false
      }
    },
    removeClick () {
      window.onbeforeunload = null
    }
  }
}
